import { Item } from "@/dto/item";
import { Modifier } from "@/dto/modifier";
import { RetailCartValue, RestaurantCartValue } from "@/models/cart/types";
import { ServiceItem } from "@/dto/serviceItem";

export const getPrice = ({
  item,
  filteredModifierGroups,
  allModifiers,
  selectedModifiers,
  itemModifiers,
  quantity,
  MIN_QUANTITY,
  isPerUnitService = false,
}: {
  item: Item | ServiceItem | RetailCartValue | RestaurantCartValue;
  filteredModifierGroups?: any;
  allModifiers?: Modifier[];
  selectedModifiers?: any;
  itemModifiers?: Modifier[];
  quantity?: number;
  MIN_QUANTITY?: number;
  isPerUnitService?: boolean;
}) => {
  if (!quantity) {
    quantity = MIN_QUANTITY;
  }
  if (!item) {
    return 0;
  }
  const basePrice = item.price;
  let modifiersTotal = 0;

  if (itemModifiers) {
    modifiersTotal = itemModifiers.reduce(
      (total, { price, quantity: modifierQuantity }) =>
        total + price! * (modifierQuantity || 1),
      0
    );
  } else if (filteredModifierGroups && selectedModifiers && allModifiers) {
    Object.values(filteredModifierGroups).forEach((group: any) => {
      const groupSelections = selectedModifiers[group.id];
      if (groupSelections) {
        Object.keys(groupSelections).forEach((modifierId) => {
          const modifier = allModifiers.find(
            (m: Modifier) => m.id === modifierId
          );
          if (modifier) {
            modifiersTotal +=
              (modifier.price || 0) * (groupSelections[modifierId] || 1);
          }
        });
      }
    });
  }

  const updatedTotalPrice = isPerUnitService
    ? basePrice * (quantity || 1) + modifiersTotal
    : (basePrice + modifiersTotal) * (quantity || 1);
  return updatedTotalPrice;
};
